import { useRef, useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
//import SimpleTable from "../components/ui/SimpleTable";
import UserSitesDialog from "../components/UserSitesDialog";
import Spinner from "../components/ui/Spinner";
import { List } from 'react-window';
import { useApi } from "../hooks/useApi";



export default function UsersList() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const initialized = useRef(false);
  const { apiCall } = useApi();
  const [masterList, setMasterList] = useState([]);
  const [filterEmailsEnabled, setFilterEmailsEnabled] = useState(false);
  const [filterAllSiteAccess, setFilterAllSiteAccess] = useState(false);
  const [filterProjectsAssigned, setFilterProjectsAssigned] = useState(false);
  const [filterNoProjectsAssigned, setFilterNoProjectsAssigned] = useState(false);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [filterTesters, setFilterTesters] = useState(false);
  const dialogRef = useRef(); //dialog rendering independent of the main render to avoid re render
  const [scrollbarWidth, setScrollbarWidth] = useState(0);
  useEffect(() => {
    const fetchData = async () => {
      if (!initialized.current) {
        const time = new Date().getTime();
        initialized.current = true;

        setLoading(true);
        try {
          const userjson = await apiCall(`user-get_users_site_info`);
          const userData = await userjson.json();
          setMasterList(userData || []);
          setLoading(false);
        }
        catch (error) {
          setError("Error loading users.");
        }

      }
    };
    fetchData();
  }, []);
  useEffect(() => {
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll';
    document.body.appendChild(outer);
    const inner = document.createElement('div');
    outer.appendChild(inner);
    const width = outer.offsetWidth - inner.offsetWidth;
    outer.remove();
    setScrollbarWidth(width);
  }, []);

  const highlightText = (text, query) => {
    if (!query || !text) return text;
    const regex = new RegExp(`(${query})`, "gi");
    return text.replace(regex, '<span class="bg-yellow-300">$1</span>');
  };



  useEffect(() => {
    // Skip if masterList is empty
    if (!masterList.length) {
      setFilteredUsers([]);
      return;
    }

    // Set loading to true immediately
    setLoading(true);

    // Use a timeout to let the UI update with the loading state
    const timer = setTimeout(() => {
      // Perform the filtering
      const result = masterList
        .filter((user) =>
          user.user_email.toLowerCase().includes(searchTerm.toLowerCase()) ||
          (user.user_name && user.user_name.toLowerCase().includes(searchTerm.toLowerCase()))
        )
        .filter((user) => (filterEmailsEnabled ? user.emails_enabled : true))
        .filter((user) => (filterAllSiteAccess ? user.all_site_access : true))
        .filter((user) => (filterProjectsAssigned ? user?.sitelist : true))
        .filter((user) => (filterTesters ? user?.is_tester : true))
        .filter((user) => (filterNoProjectsAssigned ? !user?.sitelist : true));

      // Update state and turn off loading
      setFilteredUsers(result);
      setLoading(false);
    }, 0); // Zero delay still defers execution until after render

    // Cleanup to avoid race conditions if dependencies change quickly
    return () => clearTimeout(timer);
  }, [
    masterList,
    searchTerm,
    filterEmailsEnabled,
    filterAllSiteAccess,
    filterProjectsAssigned,
    filterNoProjectsAssigned,
    filterTesters,
  ]);

  const UserRow = ({ index, style, items }) => {
    const user = items[index];

    return (
      <div style={style} key={user.user_email} className="flex border border-t-0">
        <div className="p-2 w-[30%] border-r flex justify-between items-center">

          <Link to={`/edit-user/${btoa(user.user_email)}`} className="text-blue-600 hover:underline" dangerouslySetInnerHTML={{ __html: highlightText(user.user_email, searchTerm) + (user.external ? ' (External)' : '') }}>
          </Link>
          <Link to={`/edit-user/${btoa(user.user_email)}`} className="text-blue-600 hover:underline">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125" />
            </svg>
          </Link>
        </div>
        <div className="p-2 w-[23%] border-r flex items-center" dangerouslySetInnerHTML={{ __html: highlightText(user.user_name, searchTerm) }}>
        </div>
        <div className="p-2 w-[7%] border-r flex items-center" >
          {user.emails_enabled ? 'Yes' : ''}
        </div>
        <div className="p-2 w-[10%] border-r flex items-center" >
          {user.all_site_access ? 'Yes' : ''}
        </div>
        <div className="p-2 w-[30%] flex flex-row gap-2 flex-wrap items-center overflow-hidden">
          {user.sitelist && user.sitelist.length && (
            <>
              <ul className="flex flex-row gap-2 flex-wrap items-center h-[100%]">
                {user.sitelist.slice(0, 4).map((site) => (
                  <li key={site.id} className="bg-neutral-200 rounded-sm p-1.5 uppercase">
                    {site.site_number}
                  </li>
                ))}

              </ul>
              {user.sitelist.length && user.sitelist.length > 4 && (
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    dialogRef.current.open(user.sitelist);
                  }}
                  className="p-1.5 cursor-pointer"
                >
                  <span className="bg-blue-50 p-2 hover:bg-blue-100"> +{user.sitelist.length - 4} More...</span>
                </button>
              )}
            </>


          )}
        </div>
      </div>
    );
  };



  if (error) return <p>Error: {error}</p>;
  return (

    <div className="p-6">
      {/* Loading overlay */}
      <Spinner loading={loading}></Spinner>
      <UserSitesDialog ref={dialogRef} />
      <div className="flex justify-between items-center mb-4">

        <h1 className="text-2xl font-bold">Users List</h1>
        <Link to="/add-user" className="btn btn-primary">
          Add New User
        </Link>
      </div>
      <div className="flex justify-between items-end">
        <div>
          <label className="flex w-fit mb-4">
            <input
              type="checkbox"
              checked={filterEmailsEnabled}
              onChange={(e) => setFilterEmailsEnabled(e.target.checked)}

              className="mr-2"
            />
            Emails Enabled
          </label>
          <label className="flex w-fit items-center mb-4">
            <input
              type="checkbox"
              checked={filterAllSiteAccess}
              onChange={(e) => setFilterAllSiteAccess(e.target.checked)}
              className="mr-2"
            />
            All Projects Access
          </label>
          <label className="flex w-fit items-center mb-4">
            <input
              type="checkbox"
              checked={filterTesters}
              onChange={(e) => setFilterTesters(e.target.checked)}
              className="mr-2"
            />
            Testers
          </label>
        </div>
        <div>
          <label className="flex w-fit items-center mb-4">
            <input
              type="checkbox"
              checked={filterProjectsAssigned}
              onChange={(e) => setFilterProjectsAssigned(e.target.checked)}
              className="mr-2"
            />
            Projects Assigned
          </label>
          <label className="flex w-fit items-center mb-4">
            <input
              type="checkbox"
              checked={filterNoProjectsAssigned}
              onChange={(e) => setFilterNoProjectsAssigned(e.target.checked)}
              className="mr-2"
            />
            No Projects Assigned
          </label>
        </div>


      </div>
      <div>
        <input
          type="text"
          placeholder="Search by user email or name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="border p-2 rounded w-full mb-4"
        />

      </div>
      {!loading && filteredUsers.length < 1 ? 'No results' : ''}
      {filteredUsers.length > 0 && (
        <div className="table-container">
          <div className="flex bg-gray-100 font-bold border" style={{ paddingRight: scrollbarWidth }}>
            <div className="p-2 w-[30%] border-r ">Email</div>
            <div className="p-2 w-[23%] border-r">Name</div>
            <div className="p-2 w-[7%] border-r ">Emails Enabled</div>
            <div className="p-2 w-[10%] border-r">All Projects</div>
            <div className="p-2 w-[30%] ">Projects</div>
          </div>
          <div className="table-body" >
            <List
              style={{ height: '800px' }}
              height={800}
              width="100%"
              rowCount={filteredUsers.length}   // Total number of items
              rowHeight={50}            // Height of each item
              rowComponent={UserRow}    // The component to render
              rowProps={{ items: filteredUsers }} // FEED DATA HERE (as an object)
              overscanCount={5}
            />
          </div>
        </div>
      )}
    </div>
  );
}
